// Get all forms requested
export const GET_ALL_FORMS_REQUESTED = "GET_ALL_FORMS_REQUESTED";
export const GET_ALL_FORMS_REQUESTED_SUCCESS =
  "GET_ALL_FORMS_REQUESTED_SUCCESS";
export const GET_ALL_FORMS_REQUESTED_ERROR = "GET_ALL_FORMS_REQUESTED_ERROR";
export const GET_ALL_FORMS_REQUESTED_CLEAR_DATA =
  "GET_ALL_FORMS_REQUESTED_CLEAR_DATA";
// ****---END---****
